var _path, _path2, _path3, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4165 5.8333C23.3332 -2.50009 39.9998 6.66671 20.4165 20.4166",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2231 5.83324C17.3065 -2.50015 0.639812 6.66665 20.2231 20.4166",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 10.4167L19.9998 13.3333L24.5832 8.75",
    stroke: "#2E2E2E",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_44981_9427",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 21.6667,
    width: 5.83333,
    height: 14.1667,
    rx: 0.833333
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 21.6667,
    width: 5.83333,
    height: 14.1667,
    rx: 0.833333,
    stroke: "#2E2E2E",
    strokeWidth: 3.33333,
    mask: "url(#path-4-inside-1_44981_9427)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_44981_9427",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.8335,
    y: 19.1667,
    width: 5.83333,
    height: 19.1667,
    rx: 0.833333
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.8335,
    y: 19.1667,
    width: 5.83333,
    height: 19.1667,
    rx: 0.833333,
    stroke: "#2E2E2E",
    strokeWidth: 3.33333,
    mask: "url(#path-5-inside-2_44981_9427)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_44981_9427",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.83333,
    height: 14.1667,
    rx: 0.833333
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.83333,
    height: 14.1667,
    rx: 0.833333,
    transform: "matrix(-1 0 0 1 38.3335 21.6667)",
    stroke: "#2E2E2E",
    strokeWidth: 3.33333,
    mask: "url(#path-6-inside-3_44981_9427)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_44981_9427",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.83333,
    height: 19.1667,
    rx: 0.833333
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5.83333,
    height: 19.1667,
    rx: 0.833333,
    transform: "matrix(-1 0 0 1 34.1665 19.1667)",
    stroke: "#2E2E2E",
    strokeWidth: 3.33333,
    mask: "url(#path-7-inside-4_44981_9427)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6668,
    y: 26.6666,
    width: 16.6667,
    height: 4.16667,
    stroke: "#2E2E2E",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/Healthcare.c94714e65e33f80bb308991a181f29ff.svg";
export { ForwardRef as ReactComponent };